import { Component, OnInit, Input } from '@angular/core';
import { HomeService } from 'src/app/core/http/web/home.service';
import { SuscribeWPService } from 'src/app/core/http/web/suscribe.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-subscribe',
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.scss']
})
export class SubscribeComponent implements OnInit {
  public errors: any = null;
  public loadings: any = true;
  @Input('route') public route: string;
  @Input('load_serv') public load_serv: boolean = true;
  @Input('data') public subscribeData: any = null;
  public form: FormGroup;
  public submited: boolean;
  public validEmail: boolean;
  public bockButton: boolean;
  public showMsj: boolean = false;
  constructor(
    private _homeService: HomeService,
    private suscrService: SuscribeWPService,
    private formB: FormBuilder
  ) { }
  ngOnInit() {
    this.form = this.formB.group({
      fEmail: ['', [Validators.required, Validators.email]]
    });
    if (this.load_serv) {
      this.getSubscribe();
    }
  }
  get f() { return this.form.controls; }

  getSubscribe() {
    this._homeService.getSubscribe(this.route).subscribe(data => {
      console.log('Subscribe', data);
      this.subscribeData = data.suscribete;
      if (!(data.suscribete)) {
        console.warn('Sin promociones productos para mostrar');
        this.loadings = false;
      }
    }, err => {
      console.error(err);
      this.errors = err;
    });
  }

  onChange(newValue) {
    const validEmailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (validEmailRegEx.test(newValue)) {
        this.validEmail = true;
    } else {
      this.validEmail = false;
    }
  }

  submit() {
    this.submited = true;
    if(!(!this.validEmail || this.bockButton)){
      console.log('Submit', this.form.value);
      this.form.controls.fEmail.setErrors(null);
      if (this.form.valid) {
        this.validaEmail();
        console.log('Formulario email valid');
      }
    }else{
      console.log("No hay correo");
      this.form.controls.fEmail.setErrors({'incorrect': true});
    }
  }

  validaEmail() {
    this.bockButton = true;
    this.suscrService.validaEmail(this.form.value.fEmail).subscribe(data => {
      console.log('Subscribe valida email: ', data);
      this.emailValided(data);
      this.bockButton = false;
    }, err => {
      console.error(err);
      this.errors = err;
    });
  }

  emailValided(data) {
    if (data.status === 1) {
      console.log('Abriendo modal');
      localStorage.setItem('newsletter', JSON.stringify(data));
      $('#newsletterModal').modal('show');
    } else {
      this.form.controls.fEmail.setValue('');
      this.submited = false;
      setTimeout(() => {
        console.log('Mostrando mensaje');
        this.showMsj = false;
      }, 4000);
      console.log('Ocultando mensaje');
      this.showMsj = true;
    }
  }
  clearNewsLetter($data) {
    console.log('Limpiando datos de suscripción:');
    this.form.controls.fEmail.setValue('');
    this.submited = false;
  }

  reload() {
    this.loadings = true;
    this.getSubscribe();
  }

}
